import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

// Components
import ModalHeader from '@common-components/headers/ModalHeader';
import Button from '@common-components/button/Button';
import { INPUT_TYPES } from '@common-components/form/constants/fieldTypes';
import { configs } from '@constants/configs/configs';
const { endpoints } = configs;
import { environmentSelector } from '@selectors/commonSelectors';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';



const AddedToBOBModal = ( props ) => {
    const {
        actions: {
            hideModal
        },
        modal: {
            modalData: {
                memberName
            }
        },
        modalHeaderProps
    } = props;
    const { activeModuleName } = useSelector(environmentSelector).user;

    const handleRestorationClick = () => {
        const normalizedRole = activeModuleName.toUpperCase(); 
        const redirectUrl = normalizedRole === ALL_USER_ROLES.ASSISTER ? endpoints.EDE_BACK_TO_ACTIVE_INDIVIDUALS_ASSISTER : endpoints.EDE_BACK_TO_ACTIVE_INDIVIDUALS_BROKER;
        window.location.href = redirectUrl;
    };



    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps, hideModal, hideModalCallback: handleRestorationClick } } />
            </div>
            <div className="gi-modal__body txt-left" id={`${modalHeaderProps.modalId}_body`}>
                <FormattedMessage
                    id='selfDesignation.search.becomeAOR.modal.success.content.1'
                    values={{
                        name: memberName.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()),
                        strong: function makeTextStrong (chunks) { return (<strong>{ chunks }</strong>); },
                        linebreak: <br />,
                    }}
                    tagName='p'
                />
            </div>
            <div className='gi-modal__controls'>
                <Button
                    { ...{
                        id:'modal-close-btn',
                        name:'closeBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'margin-r-10', 'display--inline'],
                        classes:['gi-button__secondary'],
                        btnText:'selfDesignation.search.action-btn.close',
                        handleClick: handleRestorationClick
                    }}

                />
            </div>
        </Fragment>
    );
};

export default AddedToBOBModal;